import script from "./SupplierBrandGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierBrandGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QStep});
